import { normalizeMultiPrimaryDefaults } from '@/components/Form/_hooks/normalizeMultiPrimaryDefaults';
import { EMPTY_PRIMARY_ROW } from '@/components/Form/FormAutocompleteField/MultiPrimaryAutocompleteField';
import type { Address, ParentHco } from '@/core/graphql/generated/types';
import type { HcoProfile } from '@/pages/HcoProfilePage/_hooks/useHcoData';

import type { HcoDcrValuesIn } from '../_schemas/hcoSchema';

import { mapAddressesIn } from './mapAddressesIn';
import { mapParentHcosIn } from './mapParentHcosIn';

export const HCO_EMPTY_DEFAULTS_IN: HcoDcrValuesIn = {
	// Name
	hcoNameCda_V: '',

	// Organizational
	hcoType: '',
	hcoTypeLocal_VId: '',
	typeOfHierarchy_VId: '',
	countHcp_VId: '',
	countPrescriber_VId: '',
	allSpecLocal_VId: [EMPTY_PRIMARY_ROW],
	statusCda_V: '',
	nhidCda_V: '',
	hcoTaxId_V: '',
	hcoOwnership_VId: '',
	academicStatus_VId: '',
	// vaDodAffiliated_V: false,

	// Contact
	// Note(Filip): As of 27.01.2026 - Jonas reqested these to be hidden for the time being
	// officePhoneCda_V: '',
	// faxCda_V: '',
	emailCda_V: '',
	websiteCda_V: '',

	// Addresses
	addresses: [],

	// Affiliations
	parenthcos: [],

	// Attachments
	attachments: [],

	newEntityCountryId: ''
};

export const mapHcoToFormDefaultsIn = (hco: HcoProfile): HcoDcrValuesIn => {
	const parentSearch =
		hco.parentAffiliationSearch.__typename === 'HCOAffiliationsResults'
			? hco.parentAffiliationSearch
			: null;

	return {
		// Name
		hcoNameCda_V: hco.hcoNameCda_V ?? '',

		// Organizational
		hcoType: hco.hcoType?.name ?? '',
		hcoTypeLocal_VId: hco.localHcoType?.name ?? '',
		typeOfHierarchy_VId: hco.hcoHierarchyType?.name ?? '',
		countHcp_VId: hco.hcpCount?.name ?? '',
		countPrescriber_VId: hco.prescriberCount?.name ?? '',
		statusCda_V: hco.statusCda_V ?? '',
		nhidCda_V: hco.nhidCda_V ?? '',
		hcoTaxId_V: hco.hcoTaxId_V ?? '',
		hcoOwnership_VId: hco.ownership?.name ?? '',
		academicStatus_VId: hco.academicStatus?.name ?? '',
		businessType_V: hco.businessType_V ?? '',
		allSpecLocal_VId: normalizeMultiPrimaryDefaults(
			[
				hco.primaryLocalSpecialty?.name,
				hco.secondaryLocalSpecialty?.name
			].filter((n): n is string => !!n)
		),

		// Contact
		// officePhoneCda_V: hco.officePhoneCda_V ?? '',
		// faxCda_V: hco.faxCda_V ?? '',
		emailCda_V: hco.emailCda_V ?? '',
		websiteCda_V: hco.websiteCda_V ?? '',

		// Local Attributes
		// Note(Filip): When enabling this, you would also need to enable the related validator in hcoSchema.ts, the place where the component is used, and `mapHcpToFormDefaultsIn`/`useHcpToNetworkApiFieldNames`
		// vaDodAffiliated_V: hco.vaDodAffiliated_V ?? false,

		// Addresses
		addresses: mapAddressesIn(hco.addresses as Address[]),

		// Affiliations
		parenthcos: mapParentHcosIn((parentSearch?.results ?? []) as ParentHco[]),

		// Attachments — local-only state, never preloaded from HCO
		attachments: []
	};
};
